import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export function sendElementsToBack(store: StoreType, elements: ElementsArray) {
    store.activePage.moveElementsBottom(elements.map(element => element.id));
}
